import { withVoltParam } from "../ui/voltFilters";

export const YEAR_PARAM = "year";
export const SORT_PARAM = "by";
export const DIR_PARAM = "dir";
export const SEARCH_PARAM = "q";

/** Year from the URL; undefined lets the API pick the latest. */
export const yearOf = (params: URLSearchParams) => {
  const y = Number(params.get(YEAR_PARAM));
  return Number.isInteger(y) && y > 0 ? y : undefined;
};

/** Link to a subpage that keeps year, sort and search for the way back. */
export const listLink = (
  path: string,
  params: URLSearchParams,
  year?: number,
) => {
  const next = year
    ? withVoltParam(params, YEAR_PARAM, String(year))
    : new URLSearchParams(params);
  const qs = next.toString();
  return qs ? `${path}?${qs}` : path;
};
